(function () {
    'use strict';

    function main() {
        var page = wo$('#share-popular-providers');
        if (!page.length) return;
        var data = WhistleOut.readLookupData(page);

        var controller = {
            init: function () {
                page.find('#embed-code-suppliers, #share-url-suppliers')
                    .off('click')
                    .click(function () {
                        WhistleOut.focusAndSelect(this, true);
                        WhistleOut.triggerPopoverNotification(this, data.resources.copied, 'bottom');
                    });

                page.on('show.bs.modal', function () {
                    var url = WhistleOut.replaceQueryString(data.embedInfoUrl, location.search);
                    wo$.ajax({
                        type: 'GET',
                        url: url,
                        async: true
                    }).done(function (updatedData) {
                        data = updatedData;
                        controller.updateShareUrl();
                        page.find('#show-heading-suppliers').attr('checked', data.IsShowHeadingChecked);
                        var customHeadingDiv = wo$('#custom-headings-suppliers');
                        if(data.IsShowHeadingChecked){
                            customHeadingDiv.removeClass('hidden');
                        } 
                        else{
                            customHeadingDiv.addClass('hidden');
                        }
                    }).always(function () {
                        controller.updatePreview(true);
                    });

                    if (page.find('input#showWidgetCode-suppliers').length) {
                        page.find('input#showWidgetCode-suppliers').prop('checked', false);
                        page.find('input#embed-code-suppliers').addClass('hidden');
                    }
                });

                page.find('input#showWidgetCode-suppliers').change(function () {
                    if (this.checked) {
                        page.find('input#embed-code-suppliers').removeClass('hidden');
                        page.find('input#embed-code-suppliers').click();
                    } else {
                        page.find('input#embed-code-suppliers').addClass('hidden');
                    }
                });

                var customHeading = wo$('#custom-headings-suppliers');
                page.find('input#show-heading-suppliers').change(function () {
                    customHeading.toggleClass('hidden');
                });

                var headingTimeout;
                page.find('input#custom-heading-input-suppliers').on('input', function () {
                    clearTimeout(headingTimeout);
                    headingTimeout = window.setTimeout(function () {
                        controller.updatePreview(true);
                    }, 1000);
                });

                var subheadingTimeout;
                page.find('input#custom-subheading-input-suppliers').on('input', function () {
                    clearTimeout(subheadingTimeout);
                    subheadingTimeout = window.setTimeout(function () {
                        controller.updatePreview(true);
                    }, 1000);
                });

                var dataUpdateTimeout;
                page.find('[data-update]').on('change', function () {
                    clearTimeout(dataUpdateTimeout);
                    dataUpdateTimeout = window.setTimeout(function () {
                        controller.updatePreview(true);
                    }, 500);
                });

                page.find('#amp-suppliers')
                    .off('click')
                    .on('click', function () {
                        controller.updatePreview(false);
                    });

                page.find('#short-url-suppliers')
                    .off('click')
                    .click(function () {
                        controller.updateShareUrl();
                        WhistleOut.focusAndSelect(wo$('#share-url-suppliers'));
                    });

                wo$(window).on('message', function (event) {
                    if (
                        event.originalEvent.data &&
                        Object.prototype.hasOwnProperty.call(event.originalEvent.data, 'sentinel') &&
                        event.originalEvent.data.sentinel === 'whistleout-widget'
                    ) {
                        page.find('#embed-preview-suppliers').height(event.originalEvent.data.height);
                    }
                });
            },

            getEncodedValue: function (page, element) {
                var value = page.find(element).val();
                return value ? encodeURIComponent(WhistleOut.encodeHtml(value)) : null;
            },

            updatePreview: function (refreshWidget) {
                try {
                    var maxNumberOfResults = page.find('#max-results-suppliers').val();
                    var showHeading = page.find('#show-heading-suppliers').is(':checked');

                    var query = 'n=' + maxNumberOfResults;

                    var code;
                    var amp = page.find('#amp-suppliers').is(':checked');
                    var embedAmpUrl = (data.embedAmpUrl + '?' + query).replace(/&/g, '&amp;');

                    var heading;
                    var subheading;
                    if (!showHeading) {
                        query = WhistleOut.appendQueryParam(query, 'h=' + showHeading);
                    } else {
                        heading = this.getEncodedValue(page, 'input#custom-heading-input-suppliers');
                        if (heading) {
                            const p = 'hd=' + heading;
                            query = WhistleOut.appendQueryParam(query, p);
                            embedAmpUrl = WhistleOut.appendQueryParam(embedAmpUrl, p);
                        }

                        subheading = this.getEncodedValue(page, 'input#custom-subheading-input-suppliers');
                        if (subheading) {
                            const p = 'shd=' + subheading;
                            query = WhistleOut.appendQueryParam(query, p);
                            embedAmpUrl = WhistleOut.appendQueryParam(embedAmpUrl, p);
                        }
                    }

                    if (amp) {
                        code = data.embedAmpFormatString.replace('{ampurl}', embedAmpUrl);
                    } else {
                        var embedUrl = data.embedUrl + '?' + query;
                        if (data.encode) {
                            embedUrl = embedUrl.replace(/&/g, '&amp;');
                        }

                        var embedIFrameUrl = (data.embedIFrameUrl + '?' + query).replace(/&/g, '&amp;');
                        code = data.embedFormatString
                            .replace('{url}', embedUrl)
                            .replace('{ampurl}', embedAmpUrl)
                            .replace('{iframeurl}', embedIFrameUrl);
                    }

                    page.find('#embed-code-suppliers').val(code).css('background-color', 'rgba(255,255,0,.3)').animate(
                        {
                            backgroundColor: 'white'
                        },
                        2000
                    );

                    if (refreshWidget) {
                        var previewUrl = WhistleOut.updateQueryStringParameter(
                            data.previewUrl,
                            'maxresults',
                            maxNumberOfResults
                        );
                        previewUrl = WhistleOut.updateQueryStringParameter(
                            previewUrl,
                            'showwidgetheading',
                            showHeading
                        );

                        if (heading) {
                            previewUrl = WhistleOut.updateQueryStringParameter(previewUrl, 'hd', heading);
                        }

                        if (subheading) {
                            previewUrl = WhistleOut.updateQueryStringParameter(previewUrl, 'shd', subheading);
                        }

                        page.find('#embed-preview-suppliers').attr('src', previewUrl);
                    }
                    // eslint-disable-next-line no-empty
                } catch (e) {}
            },

            updateShareUrl: function () {
                var url = page.find('#short-url-suppliers').is(':checked') ? data.shareShortUrl : data.shareUrl;
                page.find('#share-url-suppliers').val(url);
            }
        };

        controller.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
